import axios from 'src/utils/axios';
import { URLS } from 'src/submodules/commons-system/constants/urls';
import authService from 'src/services/authService';
import Cookies from 'js-cookie';
import { getDomainName } from 'src/utils/common';
import g7Service from 'src/submodules/commons-auth/G7/G7Service';
class RefreshTokenService {

	constructor() {
		this.isRefreshing = false; // Flag per evitare chiamate concorrenti
		this.refreshQueue = []; // Coda di richieste in attesa
	 }

	async refreshToken(){
		console.log('REFRESH TOKEN')
		const isG7View = g7Service.isG7();
		let token = this.getRefreshToken();

		if(authService.isAuthenticated && this.refreshTokenIsValid(token) && !isG7View){

			var _params = {
				refresh_token: token
			};
			var _header = {
				Authorization: `Bearer ${authService.getAccessToken()}` 
			}

			if (this.isRefreshing) {
				// Accoda la richiesta in attesa del refresh
				return new Promise((resolve) => {
				  this.refreshQueue.push(resolve);
				});
			 }
			 this.isRefreshing = true;

			return axios
			.get(URLS.PROFILES.REFRESH,{headers:_header,params:_params})
			.then(response => {
				if (response.data) {
						let accessToken = response.data.accessToken;
						let refreshToken = response.data.refreshToken;
						this.saveRefreshToken(refreshToken);
						authService.saveToken(accessToken);
						// Risolvi tutte le richieste in attesa
						this.refreshQueue.forEach((callback) => callback());
						this.refreshQueue = [];
				} else {
					Promise.reject(response.data.error);
				}
			})
			.catch(error => {
				Promise.reject(error);
			})
			.finally(() => {
			  this.isRefreshing = false;
			});
		}
	}
	 getRefreshToken() {
		var token = sessionStorage.getItem('refreshToken') ? sessionStorage.getItem('refreshToken') : Cookies.get('refreshToken');
		return token;
	 }

	saveRefreshToken = accessToken => {
		console.log('SAVE REFRESH TOKEN')
		const domain = getDomainName();
		sessionStorage.setItem('refreshToken', accessToken);
		Cookies.set('refreshToken', accessToken,{ domain, path: '/' });
	};

	refreshTokenIsValid = refreshToken =>{
		if(refreshToken && refreshToken !== null && refreshToken !== "null"){
			return true;
		}
		return false;
	};

}

const refreshTokenService = new RefreshTokenService();

export default refreshTokenService;
